<template>
  <div class="page-container">
    <div class="page-header">
      <h1 class="page-title">专家答疑</h1>
     
    </div>
    
    <!-- 消息提示弹窗 -->
    <div v-if="showMessageModal" class="message-modal-overlay" @click.self="closeMessageModal">
      <div class="message-modal" :class="messageType">
        <div class="message-content">
          <span class="message-icon">{{ messageType === 'success' ? '✓' : '⚠' }}</span>
          <p>{{ messageContent }}</p>
        </div>
        <button @click="closeMessageModal" class="message-btn">确定</button>
      </div>
    </div>
    
    <div class="page-content">
      <!-- 左侧：提问区域 -->
      <div class="left-panel">
        <div class="ask-card">
          <h3 class="card-title">💬 向专家提问</h3>
          <textarea 
            v-model="questionContent" 
            placeholder="请输入您的问题，例如：军校报考需要什么条件？" 
            class="question-input"
            maxlength="500"
          ></textarea>
          <div class="input-footer">
            <span class="char-count">{{ questionContent.length }}/500</span>
            <button @click="submitQuestion" class="submit-btn">提交问题</button>
          </div>
        </div>
      </div>
      
      <!-- 右侧：问题列表 -->
      <div class="right-panel">
        <!-- 问题列表 -->
        <div class="questions-list">
          <div 
            v-for="question in questions" 
            :key="question.id"
            @click="selectQuestion(question)"
            class="question-card"
            :class="question.status"
          >
            <div class="question-header">
              <span class="status-badge" :class="question.status">{{ getStatusLabel(question.status) }}</span>
              <span class="question-time">{{ question.time }}</span>
            </div>
            <p class="question-text">{{ question.content }}</p>
            <div v-if="question.reply" class="reply-preview">
              <span class="reply-icon">👨‍🏫</span>
              <span class="reply-text">{{ question.reply.substring(0, 50) }}...</span>
            </div>
          </div>
          
          <div v-if="questions.length === 0" class="empty-state">
            <span class="empty-icon">📭</span>
            <p>暂无问题</p>
          </div>
        </div>
        
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            background
            layout="prev, pager, next, jumper, ->, total"
            :total="total"
            :page-size="pageSize"
            v-model:current-page="currentPage"
            @current-change="handlePageChange"
          />
        </div>
      </div>
      
      <!-- 问题详情弹窗 -->
      <div v-if="selectedQuestion" class="modal-overlay" @click.self="closeModal">
        <div class="detail-modal">
          <div class="modal-header">
            <h3 class="modal-title">问题详情</h3>
            <button @click="closeModal" class="close-btn">✕</button>
          </div>
          <div class="modal-content">
            <div class="question-section">
              <div class="section-header">
                <span class="status-badge large" :class="selectedQuestion.status">{{ getStatusLabel(selectedQuestion.status) }}</span>
                <span class="question-time">{{ selectedQuestion.time }}</span>
              </div>
              <p class="question-content">{{ selectedQuestion.content }}</p>
            </div>
            
            <div v-if="selectedQuestion.reply" class="reply-section">
              <div class="section-header">
                <span class="reply-label">👨‍🏫 专家回复</span>
              </div>
              <div class="reply-content">
                <p>{{ selectedQuestion.reply }}</p>
              </div>
            </div>
            
            <div v-else class="no-reply">
              <span class="waiting-icon">⏳</span>
              <p>专家正在为您解答，请耐心等待...</p>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="closeModal" class="close-modal-btn">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getallExpertAnswerList, submitExpertQuestion, markAsRead } from "@/api/expertApi";

export default {
  name: "ExpertConsultation",
  components: {},
  data() {
    return {
      questionContent: '',
      selectedQuestion: null,
      showMessageModal: false,
      messageContent: '',
      messageType: 'success',
      questions: [],
      // 分页参数
      currentPage: 1,
      pageSize: 3,
      total: 0
    };
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    fetchQuestions(pageNum = 1, pageSize = this.pageSize) {
      console.log('请求参数:', { pageNum, pageSize });
   getallExpertAnswerList(pageNum, pageSize).then(response => {
        console.log('接口返回:', response.data);
        if (response.data.code === 200) {
          const data = response.data.data;
          console.log('数据列表:', data);
          if (data && data.list) {
            this.questions = data.list.map(item => ({
              id: item.id,
              content: item.questions,
              reply: item.answer || null,
              time: item.createTime,
              answerTime: item.answertime,
              status: this.getStatusFromIsRead(item.isRead)
            }));
            this.total = data.total || 0;
            this.currentPage = data.pageNum || 1;
            this.pageSize = data.pageSize || 3;
            console.log('处理后的questions:', this.questions);
          } else {
            console.error('数据结构不正确:', data);
            this.questions = [];
            this.total = 0;
          }
        }
      }).catch(error => {
        console.error('获取答疑列表失败:', error);
        this.questions = [];
        this.total = 0;
      });
    },
    
    handlePageChange(pageNum) {
      this.currentPage = pageNum;
      this.fetchQuestions(pageNum, this.pageSize);
    },
    
    getStatusFromIsRead(isRead) {
      // 0: 待回复，1: 已回复
      return isRead === 0 ? 'pending' : 'answered';
    },
    
    submitQuestion() {
      if (!this.questionContent.trim()) {
        this.showMessage('请输入您的问题', 'error');
        return;
      }
      
      submitExpertQuestion(this.questionContent.trim()).then(response => {
        if (response.data.code === 200) {
          this.questionContent = '';
          this.showMessage('问题提交成功！专家将在1-3个工作日内回复。', 'success');
          this.fetchQuestions();
        } else {
          this.showMessage('提交失败，请稍后重试', 'error');
        }
      }).catch(error => {
        console.error('提交问题失败:', error);
        this.showMessage('提交失败，请稍后重试', 'error');
      });
    },
    
    showMessage(content, type = 'success') {
      this.messageContent = content;
      this.messageType = type;
      this.showMessageModal = true;
    },
    
    closeMessageModal() {
      this.showMessageModal = false;
    },
    
    selectQuestion(question) {
      if (question.status === 'unread') {
        markAsRead(question.id).then(response => {
          if (response.data.code === 200) {
            question.status = 'read';
          }
        }).catch(error => {
          console.error('标记已读失败:', error);
        });
      }
      this.selectedQuestion = question;
    },
    
    closeModal() {
      this.selectedQuestion = null;
    },
    
    getStatusLabel(status) {
      const labels = {
        pending: '待回复',
        answered: '已回复'
      };
      return labels[status] || status;
    }
  }
};
</script>

<style scoped>
.page-container {
  margin-top: 60px;
  padding: 10px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f4f8 100%);
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 26px;
  color: #1e40af;
  margin: 0 0 6px 0;
  font-weight: 600;
}

.page-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.page-content {
  display: flex;
  gap: 20px;
  max-width: 1440px;
  width: calc(100% - 20px);
  margin: 0 auto;
}

.left-panel {
  width: 35%;
  flex-shrink: 0;
}

.right-panel {
  flex: 1;
  min-width: 0;
  position: relative;
  padding-bottom: 80px;
}

.ask-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.card-title {
  font-size: 18px;
  color: #333;
  margin: 0 0 15px 0;
  font-weight: 600;
}

.question-input {
  width: 100%;
  height: 100px;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s;
}

.question-input:focus {
  border-color: #1976d2;
}

.question-input::placeholder {
  color: #bbb;
}

.input-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.char-count {
  font-size: 12px;
  color: #999;
}

.submit-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}



.questions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.question-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border-left: 4px solid #e0e0e0;
}

.question-card:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.question-card.pending {
  border-left-color: #ff9800;
}

.question-card.answered {
  border-left-color: #4caf50;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.status-badge {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 500;
}

.status-badge.pending {
  background: #fff3e0;
  color: #f57c00;
}

.status-badge.answered {
  background: #e8f5e9;
  color: #388e3c;
}

.status-badge.large {
  font-size: 14px;
  padding: 5px 14px;
}

.question-time {
  font-size: 12px;
  color: #999;
}

.question-text {
  font-size: 15px;
  color: #333;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.reply-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #eee;
}

.reply-icon {
  font-size: 16px;
}

.reply-text {
  font-size: 13px;
  color: #666;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: white;
  border-radius: 12px;
}

.empty-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

.empty-state p {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.pagination-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.detail-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.question-section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.reply-label {
  font-size: 14px;
  color: #1976d2;
  font-weight: 600;
}

.question-content {
  font-size: 15px;
  color: #333;
  line-height: 1.7;
  margin: 0;
  padding: 12px;
  background: #fafafa;
  border-radius: 8px;
}

.reply-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
}

.reply-content {
  margin: 0;
}

.reply-content p {
  font-size: 14px;
  color: #333;
  line-height: 1.8;
  white-space: pre-wrap;
  margin: 0;
}

.no-reply {
  text-align: center;
  padding: 30px 20px;
  background: #fff8e1;
  border-radius: 12px;
}

.waiting-icon {
  font-size: 36px;
  display: block;
  margin-bottom: 12px;
}

.no-reply p {
  font-size: 14px;
  color: #f57c00;
  margin: 0;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.close-modal-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.message-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 20px;
}

.message-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 360px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.message-content {
  margin-bottom: 20px;
}

.message-icon {
  display: inline-block;
  width: 48px;
  height: 48px;
  line-height: 48px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
}

.message-modal.success .message-icon {
  background: #e8f5e9;
  color: #4caf50;
}

.message-modal.error .message-icon {
  background: #ffebee;
  color: #f44336;
}

.message-content p {
  font-size: 15px;
  color: #333;
  margin: 0;
  line-height: 1.6;
}

.message-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.message-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

@media (max-width: 768px) {
  .page-content {
    flex-direction: column;
  }
  
  .left-panel {
    width: 100%;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .ask-card, .question-card {
    padding: 15px;
  }
  
  .filter-bar {
    flex-wrap: wrap;
  }
  
  .filter-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>